import {
    Box,
    Container,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { DataInvalidationRow } from "./DataInvalidationRow";
import { FoodsIcon } from "@foodpilot/foods";
import { useNavigate } from "react-router";
import { URLHandler } from "src/services/URLHandler";
import { loggedInApiCall } from "src/api/axiosClient/userApi";

export const DataInvalidation = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(URLHandler.settings.list());
    };

    return (
        <Container
            component="main"
            maxWidth={false}
            sx={{
                m: "0",
                p: "48px !important",
                flexGrow: 1,
                overflow: "auto",
            }}
        >
            <Paper
                elevation={0}
                sx={{
                    width: "100%",
                    border: "1px solid #E7E6E4",
                    borderRadius: "12px",
                    overflow: "hidden",
                    backgroundColor: "white",
                }}
            >
                {/* Header */}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        padding: "32px",
                        borderBottom: "1px solid #E7E6E4",
                        backgroundColor: "white",
                    }}
                >
                    <Box
                        sx={{
                            width: "28px",
                            height: "28px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                        }}
                        onClick={handleGoBack}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                "& svg": {
                                    strokeWidth: "2px",
                                    stroke: "currentColor",
                                },
                            }}
                        >
                            <FoodsIcon icon="arrowLeftShort" size={6} />
                        </Box>
                    </Box>
                    <Box sx={{ marginLeft: "16px" }}>
                        <Typography variant="number-inter" sx={{ lineHeight: "1.6em", color: "#393A36" }}>
                            {t("settings.data_invalidation", "Cache & data invalidation")}
                        </Typography>
                    </Box>
                </Box>

                <Box sx={{ padding: "32px" }}>
                    <TableContainer
                        component={Paper}
                        elevation={0}
                        sx={{
                            border: "1px solid #E7E6E4",
                            borderRadius: "8px",
                            overflow: "hidden",
                        }}
                    >
                        <Table sx={{ "& .MuiTableCell-root": { border: "none" } }}>
                            <TableHead>
                                <TableRow
                                    sx={{
                                        backgroundColor: "#FEFCFB",
                                        "& .MuiTableCell-root": {
                                            borderBottom: "1px solid #E7E6E4",
                                            borderRight: "1px solid #E7E6E4",
                                            padding: "0px 14px 0px 20px",
                                            height: "48px",
                                            "&:last-child": {
                                                borderRight: "none",
                                            },
                                        },
                                    }}
                                >
                                    <TableCell>
                                        <Typography
                                            variant="small-medium"
                                            sx={{ lineHeight: "1.67em", color: "#767673" }}
                                        >
                                            {t("settings.data_invalidation.data", "Data")}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography
                                            variant="small-medium"
                                            sx={{ lineHeight: "1.67em", color: "#767673" }}
                                        >
                                            {t("actions", "Actions")}
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <DataInvalidationRow
                                    name={t("settings.data_invalidation.scores_cache", "Scores posts/weights cache")}
                                    action={async () => await loggedInApiCall.post("/api/clear-scores-cache")}
                                />

                                <DataInvalidationRow
                                    name={t("settings.data_invalidation.external_cache", "External API cache")}
                                    action={async () => await loggedInApiCall.post("/api/clear-external-api-cache")}
                                />

                                <DataInvalidationRow
                                    name={t("settings.data_invalidation.reference_scores", "Sure API reference scores")}
                                    action={async () => await loggedInApiCall.post("/api/reference-scores/invalidate")}
                                    actionLabel={t("translations.management.sync", "Sync with Sure API")}
                                />
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Paper>
        </Container>
    );
};
